// extracted by mini-css-extract-plugin
export default {"flairBadge":"AuthorBadgesContainer-flairBadge-7c0c64389ed28a923f9deef290a10e98"};